import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import { AppBar } from 'layout/header/Header.styles.tsx';
import MenuIcon from '@mui/icons-material/Menu';
import { ReactNode } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import useResizeObserver, { ObservedSize } from 'hooks/useResizeObserver.tsx';

import { Logo } from './Logo.tsx';
import AppBreadcrumbs from './AppBreadcrumbs.tsx';
import { useStore } from '../../store/store.ts';
import { defaultToolbarHeight } from '../../consts/appConsts.ts';
import WorkflowEditorToggle from './WorkflowEditorToggle.tsx';
import OfflineModeBadge from './OfflineModeBadge.tsx';
import UserMenu from './UserMenu.tsx';
import { useLocation } from 'react-router-dom';

type Props = {
  open: boolean;
  content?: ReactNode;
};

export const Header = ({ open, content }: Props) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const { setToolbarHeight, toggleDrawer } = useStore();
  const onResize = (value: ObservedSize) => setToolbarHeight(value.height ?? defaultToolbarHeight);
  const { ref } = useResizeObserver<HTMLDivElement>({
    onResize,
  });

  const location = useLocation();
  const isCanvas = location.pathname.includes('canvas');

  return (
    <AppBar fullWidth position="fixed" open={open} elevation={0}>
      <div className="flex w-100 justify-between">
        <div className="flex justify-start items-center">
          {isSmallScreen && (
            <IconButton className="px-8" onClick={toggleDrawer} aria-label="close">
              <MenuIcon />
            </IconButton>
          )}
          <Logo />
        </div>
        <Toolbar
          ref={ref}
          disableGutters
          sx={{
            flex: 1,
            display: 'grid',
            gridTemplateColumns: isCanvas ? 'minmax(0, 1fr) auto 1fr' : 'minmax(0, 1fr) auto',
            alignItems: 'center',
            gap: 1,
            paddingLeft: { xs: 2, sm: 3 },
            paddingRight: 1.5,
          }}
        >
          <Box id="header-title-box" mb={1} mt={1} minWidth={0}>
            <AppBreadcrumbs />
          </Box>
          {isCanvas && <WorkflowEditorToggle />}
          <Box sx={{ justifySelf: 'end', display: 'flex', alignItems: 'center' }}>
            {content}
            <OfflineModeBadge />
            <UserMenu withDivider={!!content} />
          </Box>
        </Toolbar>
      </div>
    </AppBar>
  );
};
